import axios from 'axios';
import { Resolve } from '.';
import config from './config';
import { reject } from 'lodash';

const url = process.env.VUE_APP_SERVER_PATH;
const apiKey = process.env.VUE_APP_API_KEY;
const youverseApiKey = 'pxvvTrR0WLADVGbshvO8TbcDv7QFxx0e99YN3I4uzjM0R4JJRUaFa56vpt74';

export const generateToken = (email: string, event_id: number, location = 'PT') =>
  new Promise((resolve: Resolve<any>) => {
    const requestUrl = `${url}/v2/youid/generate_token`;
    const payload = {
      email: email,
      event_id: event_id,
      location: location,
    };

    const headers = {
      'Content-Type': 'application/json',
      'x-api-key': apiKey
    };

    axios
      .post(requestUrl, payload, { ...config(), headers })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        resolve(err);
      });
  });

export const getStatus = (user_id: string) =>
  new Promise((resolve: Resolve<any>) => {
    const requestUrl = `${url}/v2/youid/get_status?user_id=${encodeURIComponent(user_id)}`;

    const headers = {
      'Content-Type': 'application/json',
      'x-api-key': apiKey
    };

    axios
      .get(requestUrl, { ...config(), headers })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        resolve(err);
      });
  });

export const processImage = (image: string) =>
  new Promise((resolve: Resolve<any>) => {
    const requestUrl = `${url}/v2/youid/process_face`;

    const headers = {
      'Content-Type': 'application/json',
      'x-api-key': youverseApiKey
    };

    axios
      .post(requestUrl, { image }, { "headers": headers })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        resolve(err);
      });
  });

export const addToYouverseGroup = (face_id: string, user_email: string, event_id: number) =>
  new Promise((resolve: Resolve<any>) => {
    const requestUrl = `${url}/v2/youid/add_to_gallery`;

    const headers = {
      'Content-Type': 'application/json',
      'x-api-key': youverseApiKey
    };

    return axios
      .post(requestUrl, { face_id, user_email, event_id }, { ...config(), headers })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        resolve(err);
      });
  });

export const searchInYouverse = (email: string, gallery: string) =>
  new Promise((resolve: Resolve<any>, reject) => {
    const requestUrl = `${url}/v2/youid/search_in_gallery`;

    const headers = {
      'Content-Type': 'application/json',
      'x-api-key': youverseApiKey
    };

    axios
      .get(requestUrl, {
        ...config(),
        headers,
        params: { email, gallery }
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const identifyFace = (template: string, event_id: number) =>
  new Promise((resolve: Resolve<any>) => {
    const requestUrl = `${url}/v2/youid/identify_face`;
    const payload = {
      template: template,
      event_id: event_id,
    };

    const headers = {
      'Content-Type': 'application/json',
      'x-api-key': youverseApiKey
    };

    axios
      .post(requestUrl, payload, { ...config(), headers })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        resolve(err);
      });
  });

export const deleteFromGallery = (email: string, gallery: string) =>
  new Promise((resolve: Resolve<any>, reject) => {
    const requestUrl = `${url}/v2/youid/delete_from_gallery`;

    const headers = {
      'Content-Type': 'application/json',
      'x-api-key': youverseApiKey
    };

    axios
      .delete(requestUrl, { 
        ...config(),
        headers, 
        params: { email, gallery } 
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });

